import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Field, reduxForm } from 'redux-form'
import IconButton from '@/ui/Button'
import ActionHide from '@/icons/Delete'
import compose from 'recompose/compose'
import withProps from 'recompose/withProps'

import translate from '../../i18n/translate'

const emptyRecord = {}

export class FilterForm extends Component {
  getShownFilters() {
    const { filters, displayedFilters, initialValues } = this.props
    return filters.filter(
      filterElement =>
        filterElement.props.alwaysOn ||
        displayedFilters[filterElement.props.source] ||
        typeof initialValues[filterElement.props.source] !== 'undefined',
    )
  }

  handleHide = event => this.props.hideFilter(event.currentTarget.dataset.key)

  render() {
    const { resource, translate } = this.props

    return this.getShownFilters()
      .reverse()
      .map(filterElement => (
        <div
          key={filterElement.props.source}
          data-source={filterElement.props.source}
          className="filter-field"
        >
          <If condition={!filterElement.props.alwaysOn}>
            <IconButton
              className="hide-filter"
              onClick={this.handleHide}
              data-key={filterElement.props.source}
              tooltip={translate('i18n.action.remove_filter')}
            >
              <ActionHide />
            </IconButton>
          </If>
          <Field
            allowEmpty
            {...filterElement.props}
            name={filterElement.props.source}
            component={filterElement.type}
            resource={resource}
            record={emptyRecord}
          />
        </div>
      ))
  }
}

FilterForm.propTypes = {
  resource: PropTypes.string.isRequired,
  filters: PropTypes.arrayOf(PropTypes.node).isRequired,
  displayedFilters: PropTypes.object.isRequired,
  hideFilter: PropTypes.func.isRequired,
  initialValues: PropTypes.object,
  translate: PropTypes.func.isRequired,
}

export const mergeInitialValuesWithDefaultValues = ({ initialValues, filters }) => ({
  initialValues: {
    ...filters
      .filter(filterElement => filterElement.props.alwaysOn && filterElement.props.defaultValue)
      .reduce(
        (acc, filterElement) => ({
          ...acc,
          [filterElement.props.source]: filterElement.props.defaultValue,
        }),
        {},
      ),
    ...initialValues,
  },
})

const enhance = compose(
  translate,
  withProps(mergeInitialValuesWithDefaultValues),
  reduxForm({
    form: 'filterForm',
    enableReinitialize: true,
    onChange: (values, dispatch, props) => props.setFilters(values),
  }),
)

export default enhance(FilterForm)



// WEBPACK FOOTER //
// ./ui/DataTable/FilterForm.js